/** Formatting helpers shared across pages. Locale-aware, allocation-light. */

const currencyFmt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
})

const currencyCentsFmt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const compactFmt = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
})

const numberFmt = new Intl.NumberFormat("en-US")

export function formatCurrency(value: number, cents = false): string {
  return (cents ? currencyCentsFmt : currencyFmt).format(value)
}

export function formatCompact(value: number): string {
  return compactFmt.format(value)
}

export function formatNumber(value: number): string {
  return numberFmt.format(value)
}

export function formatPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`
}

export function formatDate(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })
}

export function formatDateTime(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

/** Relative time such as "3h ago" / "in 2d" using the native formatter. */
const relativeFmt = new Intl.RelativeTimeFormat("en-US", { numeric: "auto" })
const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: "seconds" },
  { amount: 60, unit: "minutes" },
  { amount: 24, unit: "hours" },
  { amount: 7, unit: "days" },
  { amount: 4.34524, unit: "weeks" },
  { amount: 12, unit: "months" },
  { amount: Number.POSITIVE_INFINITY, unit: "years" },
]

export function formatRelative(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input
  let duration = (date.getTime() - Date.now()) / 1000
  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return relativeFmt.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }
  return relativeFmt.format(Math.round(duration), "years")
}

export function initials(name: string): string {
  return (
    name
      .trim()
      .split(/\s+/)
      .map((part) => part[0])
      .slice(0, 2)
      .join("")
      .toUpperCase() || "?"
  )
}
